import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { OnsiteTask, DiaryTasksService } from '@app/shared/services/diary-tasks.service';
import {BsModalRef} from "ngx-bootstrap";
import {SidepanelModalService} from "@app/sidepanel/services/sidepanel-modal.service";
import {
    ViewTaskDetailImagesComponent
} from "@app/shared/cs-components/view-task-details/view-task-detail-images/view-task-detail-images.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AppValidators} from "@app/directives";
import {CsToastBoxService} from "@app/services";

@Component({
    selector: 'app-task-details',
    templateUrl: './task-detail.component.html',
    styleUrls: ['task-detail.component.scss'],
})
export class TaskDetailComponent implements OnInit {
    @Input() tab: string;
    @Input() tasks: OnsiteTask[] = [];
    @Input() loading: boolean = false;
    @Input() error: string = '';
    @Input() diaryId: number;
    @Output() taskDeleted = new EventEmitter<void>();
    bsModalRef: BsModalRef;

    deleteConfirmationForm: FormGroup;
    showDeleteConfirmationModal: boolean = false;
    taskToDelete: OnsiteTask | null = null;
    action: string = '';

    constructor(
        private modalService: SidepanelModalService,
        private fb: FormBuilder,
        private diaryTasksService: DiaryTasksService,
        private toastService: CsToastBoxService,
    ) {}

    ngOnInit() {
        this.deleteConfirmationForm = this.fb.group({
            'confirmationText': ['', [Validators.required, AppValidators.confirmationTextValidator('DELETE')]]
        });
    }

    viewImage(photos: any, index: number) {
        const initialState = {
            photos: photos,
            selectedIndex: index,
        };

        this.bsModalRef = this.modalService.show(ViewTaskDetailImagesComponent, {
            initialState,
        });
        this.bsModalRef.content.closeBtnName = 'Close';
    }

    deleteTask(task: OnsiteTask) {
        this.taskToDelete = task;
        this.showDeleteConfirmationModal = true;
    }

    closeDeleteConfirmModal() {
        this.showDeleteConfirmationModal = false;
        this.deleteConfirmationForm.reset();
        this.taskToDelete = null;
        this.action = '';
    }

    confirmDelete() {
        if (this.deleteConfirmationForm.valid && this.taskToDelete) {
            this.action = 'deleting';
            this.diaryTasksService.deleteOnsiteTask(this.diaryId, this.taskToDelete.id).subscribe(
                (response) => {
                    this.tasks = this.tasks.filter(t => t !== this.taskToDelete);
                    this.toastService.show('Task deleted successfully', 1000);
                    this.closeDeleteConfirmModal();
                    this.taskDeleted.emit();
                },
                (error) => {
                    console.error('Error deleting task:', error);
                    this.action = 'failed_to_delete';
                }
            );
        }
    }

}
